import {FormErrorBox} from "common/FormErrorBox"
import {useForm} from "react-hook-form"
import {useRegisterGroup} from "hooks/query/group-query"
import {useEffect} from "react"
import {NotificationType, showNotification} from "common/Notification"

interface GroupValue {
    parentId: string | undefined
    name: string
}

export function RegisterGroup({parentId, close}: {
    parentId?: string,
    close: () => void,
}) {
    const registerMutate = useRegisterGroup()
    const {register, handleSubmit, formState: {errors}, setFocus} = useForm<GroupValue>()
    const submit = (values: GroupValue) => {
        registerMutate.mutate({
            parentId,
            name: values.name,
        }, {
            onSuccess: () => {
                showNotification("그룹이 추가되었습니다", NotificationType.SUCCESS)
                close()
            },
            onError: () => showNotification("그룹 추가가 실패했습니다")
        })
    }

    useEffect(() => {
        setFocus("name")
    }, [setFocus])
    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="modal is-active">
                <div className="modal-background" onClick={close}></div>
                <div className="modal-card model-modal">
                    <header className="modal-card-head has-background-purple">
                        <p className="modal-card-title has-text-white">그룹 추가하기</p>
                        <div className="delete is-clickable" aria-label="close" onClick={close}></div>
                    </header>
                    <section className="modal-card-body">
                        <div className="columns mb0 mt10">
                            <div className="column columns">
                                <div className=" stitlebox label">그룹이름</div>
                                <div className="column">
                                    <input className="input" type="text" placeholder="그룹이름을 입력하세요"
                                           {...register("name", {
                                               required: "그룹이름을 입력하세요",
                                               minLength: 2,
                                               // pattern: {
                                               //     value: /^[a-zA-Z0-9]{2,}$/g,
                                               //     message: "그룹이름은 영문,숫자(2글자이상)만 가능합니다"
                                               // },
                                           })}
                                    />
                                    <FormErrorBox error={errors.name}/>
                                </div>
                            </div>
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button is-purple2">그룹 추가</button>
                        <div className="button" onClick={close}>취소</div>
                    </footer>
                </div>
            </div>
        </form>
    )
}